import React, { useCallback, useEffect, useState, useContext } from 'react';
import { FBMOrdersV2Api } from '../../../../api/fbmOrdersV2';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { UserContext } from '../../../../contexts/UserContext';

const ResetFBMOrderStatusModal = ({ isOpen, onClose, onSuccess, onError, orderData }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { fbmAccount, user } = useContext(UserContext);
    const fbmOrdersV2Api = new FBMOrdersV2Api();

    useEffect(() => {
        if (!(onSuccess instanceof Function)) {
            console.error('ResetFBMOrderStatusModal intialized incorrectly onSuccess is not a function');
        }
        if (!(onError instanceof Function)) {
            console.error('ResetFBMOrderStatusModal intialized incorrectly onError is not a function');
        }
        if (!(onClose instanceof Function)) {
            console.error('ResetFBMOrderStatusModal intialized incorrectly onClose is not a function');
        }
    }, [onClose, onSuccess, onError]);

    const handleClose = () => {
        onClose();
    };

    const handleResetStatus = useCallback(async () => {
        setIsLoading(true);
        const response = await fbmOrdersV2Api.resetOrderStatus(orderData.orderId, fbmAccount.fbmAccountName);
        if (response.status) {
            onSuccess(`Order ${orderData.orderId} reset successfully`);
            handleClose();
        } else {
            onError(response.msg || 'Failed to reset status');
        }
        setIsLoading(false);
    }, [fbmAccount.fbmAccountName, fbmOrdersV2Api, handleClose, onError, onSuccess, orderData?.orderId]);

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            disableScrollLock={true}
            hideBackdrop={false}
        >
            <DialogTitle>Reset Order Status</DialogTitle>
            <DialogContent>
                {orderData && (
                    <div style={{ marginBottom: '20px' }}>
                        <Typography variant="subtitle1">
                            <strong>Order ID:</strong> {orderData.orderId}
                        </Typography>
                        <Typography variant="subtitle1">
                            <strong>FBM Order Number:</strong> {orderData.fbmOrderNum}
                        </Typography>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleResetStatus} color="primary" variant="contained" disabled={isLoading}>
                    {isLoading ? 'Resetting...' : 'Confirm Order Reset'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { ResetFBMOrderStatusModal };
